import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";
import PhoneInput from "../components/ui/UIPhoneInput.vue";

window.app.use(VueTelInput);
window.app.component("phone-input", PhoneInput);
